import React, { Component } from 'react';
import axios from 'axios';
import PageHeader from './shared/PageHeader';
import { COLORS, FONT } from './shared/tokens';
import { formatDisplayWeek } from '../../helper';
import AdminDashboard from './dashboard/AdminDashboard';
import ShopDashboard from './dashboard/ShopDashboard';
import WarehouseDashboard from './dashboard/WarehouseDashboard';
import AccountDashboard from './dashboard/AccountDashboard';
import DefaultDashboard from './dashboard/DefaultDashboard';

const TITLES = {
    admin:     'Business Overview',
    shop:      'Shop Dashboard',
    warehouse: 'Warehouse Dashboard',
    account:   'Account Dashboard',
    default:   'Dashboard',
};

export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            stats: null,
            grp: localStorage.getItem('PC_GRP_ID'),
            att: localStorage.getItem('PC_GRP_ATT'),
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { toggleLoader } = this.props;
        try {
            toggleLoader && toggleLoader(true);
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}services/query/PCDashboardStats.php`,
                { PC_GRP_ID: this.state.grp, PC_GRP_ATT: this.state.att }
            );
            if (res.data && res.data.success === 1) {
                this.setState({ stats: res.data.data, loading: false });
            } else {
                this.setState({ error: (res.data && res.data.message) || 'Failed to load dashboard.', loading: false });
            }
        } catch (e) {
            this.setState({ error: e.message || 'Failed to load dashboard.', loading: false });
        } finally {
            toggleLoader && toggleLoader(false);
        }
    }

    renderView() {
        const { stats } = this.state;
        switch (stats && stats.role) {
            case 'admin':     return <AdminDashboard data={stats} />;
            case 'shop':      return <ShopDashboard data={stats} />;
            case 'warehouse': return <WarehouseDashboard data={stats} />;
            case 'account':   return <AccountDashboard data={stats} />;
            default:          return <DefaultDashboard data={stats} />;
        }
    }

    render() {
        const { stats, loading, error } = this.state;
        const role = (stats && stats.role) || 'default';
        const win = stats && stats.window;
        const subtitle = win ? `Last 8 weeks · ${formatDisplayWeek(win.from)} – ${formatDisplayWeek(win.to)}` : undefined;

        return (
            <div style={{ padding: '20px 24px', fontFamily: FONT }}>
                <PageHeader title={TITLES[role]} subtitle={loading ? 'Loading live data…' : subtitle} />

                {error ? (
                    <div style={{
                        background: COLORS.errorBg, color: COLORS.errorText, fontFamily: FONT, fontSize: 13,
                        border: `1px solid ${COLORS.errorText}33`, borderRadius: 8, padding: '14px 18px',
                    }}>
                        Could not load dashboard data: {error}
                    </div>
                ) : loading ? (
                    <div style={{ color: COLORS.textDim, fontFamily: FONT, fontSize: 13, padding: '40px 0' }}>
                        Loading live data…
                    </div>
                ) : (
                    this.renderView()
                )}
            </div>
        );
    }
}
